import clsx from 'clsx';

import { IconBigArrowLeft } from '@/app/_componentsv2/icons/big-arrow-left';
import { IconBigArrowRight } from '@/app/_componentsv2/icons/big-arrow-right';

import {
  nav,
  navBullet,
  navBullets,
  navBulletSelected,
  navButton,
} from './carousel.css';

type CarouselNavProps = {
  bullets: number;
  onSelect?: (index: number) => void;
  selected: number;
  showBullets?: false;
};

export function CarouselNav({
  selected,
  showBullets,
  bullets,
  onSelect,
}: CarouselNavProps) {
  return (
    <section className={nav}>
      <button
        className={navButton}
        disabled={selected === 0}
        onClick={() => onSelect?.(selected - 1)}
      >
        <IconBigArrowLeft />
      </button>
      {showBullets !== false && bullets > 0 && (
        <section className={navBullets}>
          {[...new Array(bullets).keys()].map((_, index) => (
            <button
              className={clsx(navBullet, {
                [navBulletSelected]: selected === index,
              })}
              key={index}
              onClick={() => onSelect?.(index)}
            ></button>
          ))}
        </section>
      )}
      <button
        className={navButton}
        disabled={selected === bullets - 1}
        onClick={() => onSelect?.(selected + 1)}
      >
        <IconBigArrowRight />
      </button>
    </section>
  );
}
